import { MDSSelectMenuItemProps } from "@/mds/components/menu/select-menu/select-menu.types";
import { MDSMenuItem } from "@/mds/components/menu/menu-item";
import { ListBoxItem } from "react-aria-components";

export const MDSSelectMenuItem = ({
  onClick, // Extract onClick to prevent double clicks
  onHover,
  ...props
}: MDSSelectMenuItemProps) => {
  return (
    <ListBoxItem
      data-mds-name="select-menu-item"
      id={props.id}
      key={props.id}
      aria-label={props.label}
      textValue={props.textValue ?? props.label}
      onPress={onClick}
      onHoverStart={onHover}
      isDisabled={props.isDisabled}
    >
      <MDSMenuItem {...props} />
    </ListBoxItem>
  );
};
